(() => {
  if (customElements.get('products-recommendations')) {
    return;
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.spinner = document.getElementById('spinner');
    }

    connectedCallback() {
      this.setupIntersectionObserver();
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(
            'product-recommendations'
          );

          this.innerHTML = recommendations.innerHTML;
          document.querySelectorAll('product-recommendations .size-box-trigger').forEach(function(childElement) {
            childElement.addEventListener('click', function(event) {
              childElement.parentElement.parentElement.querySelector('.variants-box-container').toggleAttribute('open');
            });
          });
          this.ajaxMore();
        });
    }

    ajaxMore() {
      let recommendationMore = document.querySelector('product-recommendations .section__foot .button');
      let limit = 4;
      let that = this;
      recommendationMore.addEventListener('click', function(event) {
        event.preventDefault();
        let recommendationEle = document.querySelector('product-recommendations');
        let productsContainer = document.querySelector('product-recommendations .section__body ul');
        const regex = /(limit=)\d/g;
        let url = that.dataset.url.replace(regex, 'limit=10');
        spinnerLoader.enable(that.spinner);
        fetch(url)
          .then(response => response.text())
          .then(text => {
            let products = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelectorAll('.section__body ul li:nth-last-child(-n + 6)');
            
            for (let i = 0; i < products.length; i++) {
              productsContainer.appendChild(products[i])
            }
            recommendationMore.style.display = 'none';
            spinnerLoader.disable(that.spinner);
            document.querySelectorAll('product-recommendations .size-box-trigger').forEach(function(childElement, index) {
              if(index < 4) {
                return;
              }
              childElement.addEventListener('click', function(event) {
                childElement.parentElement.parentElement.querySelector('.variants-box-container').toggleAttribute('open');
              });
            });
          });
      })
      
    }

    setupIntersectionObserver() {
      new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          this.loadRecommendations();
        },
        {
          rootMargin: '0px 0px 200px 0px'
        }
      ).observe(this);
    }
  }

  customElements.define(
    'product-recommendations',
    ProductRecommendations
  );
})();
